export const TOOLTIP_ORIENTATIONS = { top: 'top', bottom: 'bottom', left: 'left', right: 'right' }

export function getTooltipOrientations(element, tooltipElement) {
  const { top, left, width } = element.getBoundingClientRect()
  const { height: tooltipHeight, width: tooltipWidth } = tooltipElement.getBoundingClientRect()

  const orientationX = left + width + tooltipWidth < window.innerWidth ? TOOLTIP_ORIENTATIONS.right : TOOLTIP_ORIENTATIONS.left
  const orientationY = top + tooltipHeight < window.innerHeight ? TOOLTIP_ORIENTATIONS.bottom : TOOLTIP_ORIENTATIONS.top

  return { orientationX, orientationY }
}

export function getTooltipPosition(element, tooltipElement) {
  const tooltipHeaderHeight = 52
  const tooltipArrowWidth = 25

  const { top, left, height, width } = element.getBoundingClientRect()
  const { height: tooltipHeight, width: tooltipWidth } = tooltipElement.getBoundingClientRect()

  const { orientationX, orientationY } = getTooltipOrientations(element, tooltipElement)
  const position = { left: 0, top: 0 }

  position.left =  orientationX === TOOLTIP_ORIENTATIONS.left ? left - tooltipWidth - tooltipArrowWidth : left + width
  position.top = orientationY === TOOLTIP_ORIENTATIONS.top ? top - tooltipHeight + tooltipHeaderHeight : top - (tooltipHeaderHeight + height)/2

  return position
}

export function updateTooltipElementPosition(tooltipElement, { left, top }) {
  tooltipElement.style.position = 'fixed'
  tooltipElement.style.top = `${top}px`
  tooltipElement.style.left = `${left}px`
  tooltipElement.style.display = 'block'
  tooltipElement.style.zIndex = 1000
}

export function isTooltipElementMounted(tooltipElement) {
  const { width, height } = tooltipElement.getBoundingClientRect()
  return width !== 0 && height !== 0
}